import type {
  ClientTask,
  EditClientTask,
  Priority,
  CustomColor,
  DurationOption,
} from '@/types';

export const getDueDateBadgeColor = (
  task: EditClientTask | ClientTask
): CustomColor => {
  if (!task.date) {
    return 'red';
  }

  if (task.done) {
    return 'gray';
  }

  const today = new Date(Date.now());
  const taskDay = new Date(task.date);
  taskDay.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);
  return taskDay.getTime() <= today.getTime() && !task.done ? 'red' : 'yellow';
};

export const getPriorityBadgeColor = (priority: Priority): CustomColor => {
  switch (priority) {
    case 'high':
      return 'red';
    case 'medium':
      return 'indigo';
    default:
      return 'gray';
  }
};

export const getDurationOptions = (
  i18n: ReturnType<typeof useI18n>
): DurationOption[] => {
  return [
    {
      key: 0,
      name: i18n.t('inventory.tasks.duration.no-duration'),
    },
    {
      key: 15,
      name: i18n.t('inventory.tasks.duration.15-minutes'),
    },
    {
      key: 30,
      name: i18n.t('inventory.tasks.duration.30-minutes'),
    },
    {
      key: 45,
      name: i18n.t('inventory.tasks.duration.45-minutes'),
    },
    {
      key: 60,
      name: i18n.t('inventory.tasks.duration.60-minutes'),
    },
    {
      key: 90,
      name: i18n.t('inventory.tasks.duration.90-minutes'),
    },
  ];
};
